import { Link } from 'react-router-dom';
import BotHoneypot from '@/components/feature/BotHoneypot';
import { useAuth } from '@/contexts/AuthContext';

export default function Footer() {
  const { user } = useAuth();

  // Masquer le pied de page (navigation publique, liens légaux, contact)
  // une fois l'utilisateur authentifié.
  if (user) return null;

  return (
    <footer className="bg-clinic-blue-dark text-white relative w-full">
      <BotHoneypot />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img 
              src="https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/brand/logo.jpeg" 
              alt="Clinique Sainte Famille" 
              className="h-16 w-auto mb-4 bg-white rounded-2xl p-2"
            />
            <p className="text-clinic-blue/80 text-sm">
              Votre santé, notre priorité. Des soins de qualité pour toute la famille.
            </p>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4 text-white">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-clinic-blue/80 hover:text-white transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-clinic-blue/80 hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-clinic-blue/80 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4 text-white">Informations Légales</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/mentions-legales" className="text-clinic-blue/80 hover:text-clinic-green transition-colors">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/politique-confidentialite" className="text-clinic-blue/80 hover:text-clinic-green transition-colors">
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link to="/conditions-utilisation" className="text-clinic-blue/80 hover:text-clinic-green transition-colors">
                  Conditions d'utilisation
                </Link>
              </li>
              <li>
                <Link to="/gestion-cookies" className="text-clinic-blue/80 hover:text-clinic-green transition-colors">
                  Gestion des cookies
                </Link>
              </li>
              <li>
                <Link to="/charte-deontologie" className="text-clinic-blue/80 hover:text-clinic-green transition-colors">
                  Charte de déontologie
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4 text-white">Contact</h3>
            <ul className="space-y-2 text-clinic-blue/80 text-sm">
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1 text-clinic-green"></i>
                <span>99QX+7W, Cotonou Bénin<br />04 BP 127 lot 1862 Fifadji</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-2 text-clinic-green"></i>
                <span>+229 01 95 40 58 91</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-2 text-clinic-green"></i>
                <span>+229 01 94 27 54 24</span>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2 text-clinic-green"></i>
                <span>clinicfam@yahoo.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-clinic-blue/30 mt-8 pt-8">
          <div className="text-center text-clinic-blue/70 text-sm space-y-2">
            <p>&copy; 2026 Clinique Sainte Famille. Tous droits réservés.</p>
            <p className="text-xs">
              Les données médicales collectées sont traitées conformément à la loi n°2017-20 du Bénin sur la protection des données personnelles et déclarées auprès de l'APDP.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
